/* global  */ // tUrl等のグローバル変数を宣言する

// import 'core-js/features/number/is-nan' // SwiperのIE対応
// import 'custom-event-polyfill' // SwiperのIE対応
// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

// ライブラリ読み込み用ファイル
// expose-loaderを通してインポートすることでグローバルオブジェクトにする

// import 'expose-loader?exposes[]=$&exposes[]=jQuery!jquery' // jQuery

// import 'expose-loader?exposes[]=baguetteBox!baguettebox.js' // BaguetteBox

// import 'trunk8' // Trunk8

// import './module/_hashScroll' // アンカーリンクスクロール
// import './module/_spMenuToggle' // SPメニュー開閉

import scrollLock from './functions/_scrollLock.js' // スクロールロック

// closestのポリフィル
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this
    do {
      if (Element.prototype.matches.call(el, s)) return el
      el = el.parentElement || el.parentNode
    } while (el !== null && el.nodeType === 1)
    return null
  }
}

topPage()
function topPage() {
  //  ###    ###   #####   ##   ##  ##  #####
  //  ## #  # ##  ##   ##  ##   ##  ##  ##
  //  ##  ##  ##  ##   ##  ##   ##  ##  #####
  //  ##      ##  ##   ##   ## ##   ##  ##
  //  ##      ##   #####     ###    ##  #####

  // YouTubeのAPIを呼び出す
  /* global YT */
  const tag = document.createElement('script')
  tag.src = 'https://www.youtube.com/iframe_api'
  const firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

  let topMovie
  let modalMovie

  window.onYouTubeIframeAPIReady = function () {
    topMovie = new YT.Player(
      'topMovie', // プレイヤーに変化させる要素のID
      {
        videoId: 'Quo3UDOCI64', // 動画ID
        width: 1920, // 幅
        height: 1080, // 高さ
        playerVars: {
          playsinline: 1, // インライン再生(iOS環境で制御に必要)
          controls: 0, // コントローラー
          rel: 0, // おすすめ動画
          showinfo: 0, // タイトル
          disablekb: 1, // キーボード操作の禁止
          color: 'white', // シークバーの色（red/white）
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
        },
      }
    )

    modalMovie = new YT.Player(
      'modalMovie', // プレイヤーに変化させる要素のID
      {
        videoId: 'FwoAyqSlhXM', // 動画ID
        width: 1920, // 幅
        height: 1080, // 高さ
        playerVars: {
          playsinline: 0, // インライン再生(iOS環境で制御に必要)
          controls: 1, // コントローラー
          rel: 0, // おすすめ動画
          showinfo: 0, // タイトル
          disablekb: 1, // キーボード操作の禁止
          color: 'white', // シークバーの色（red/white）
        },
      }
    )
  }
  function onPlayerReady(e) {
    // 再生準備完了時の処理
    e.target.mute() // ミュートにする（しないとブラウザに自動再生を拒否される）
    e.target.playVideo() // 再生開始
  }
  function onPlayerStateChange(e) {
    // 動画の状態変化時の処理
    if (e.data === YT.PlayerState.PLAYING) {
      // 再生中
      setTimeout(() => {
        document.getElementById('topLoad').classList.remove('active')
        document.getElementById('topReady').classList.add('active')
        document.getElementById('topMovie').classList.add('active')
        document.getElementById('topPlay').classList.add('active')
      }, 300)
    }
    if (e.data === YT.PlayerState.PAUSED) {
      // 停止
    }
    if (e.data === YT.PlayerState.BUFFERING) {
      // バッファリング中
    }
    if (e.data === YT.PlayerState.CUED) {
      // 頭出し済み
    }
    if (e.data === YT.PlayerState.ENDED) {
      // 再生終了
      e.target.playVideo() // 再度再生
    }
  }

  function playFullscreen() {
    const iframe = document.getElementById('modalMovie')

    if (window.matchMedia('(max-width:768px)').matches) {
      //SP
      const requestFullScreen =
        iframe.requestFullScreen || iframe.mozRequestFullScreen || iframe.webkitRequestFullScreen
      if (requestFullScreen) {
        requestFullScreen.bind(iframe)()

        const fullTimer = setInterval(() => {
          if (!isFullScreen()) {
            modalClose()
            document.removeEventListener('fullscreenchange')
            clearInterval(fullTimer)
          }
        }, 500)
      }
    }
  }

  //  ###    ###   #####   ####      ###    ##
  //  ## #  # ##  ##   ##  ##  ##   ## ##   ##
  //  ##  ##  ##  ##   ##  ##  ##  ##   ##  ##
  //  ##      ##  ##   ##  ##  ##  #######  ##
  //  ##      ##   #####   ####    ##   ##  ######

  const modalOverlay = document.getElementById('modalOverlay') // モーダル用オーバーレイ
  const modals = document.getElementsByClassName('js-modal') // モーダル本体
  const modalYoutube = document.getElementsByClassName('js-modal-youtube') // モーダル内YouTube
  if (modals[0]) {
    window.addEventListener('click', (e) => {
      if (!e.target.closest('.js-modal-open')) {
        return
      }
      e.preventDefault()
      modalClose()

      if (!isIphone()) {
        // iPhone以外ならMVを止めてモーダルを開く
        topMovie.pauseVideo()
        const target = e.target.closest('.js-modal-open').dataset.modal

        const openModals = document.querySelectorAll('.js-modal--' + target)
        for (const openModal of openModals) {
          openModal.classList.add('active')
        }

        modalOverlay.classList.add('active')
        scrollLock('body', '#modalOverlay')
      }

      modalMovie.playVideo()
      playFullscreen()
    })
    // モーダル撤去
    window.addEventListener('click', (e) => {
      if (!e.target.closest('.js-modal-close')) {
        return
      }
      e.preventDefault()
      modalClose()
      modalOverlay.classList.remove('active')
      scrollLock('body', '#modalOverlay')
    })
  }

  function modalClose() {
    // モーダルを消す
    for (let index = 0; index < modals.length; index++) {
      const modal = modals[index]
      modal.classList.remove('active')
    }

    topMovie.playVideo()
    modalMovie.pauseVideo()
  }
}

/**
 * フルスクリーンかどうかを返す
 * @return {Boolean} フルスクリーンならtrue
 */
function isFullScreen() {
  if (
    (document.fullscreenElement && document.fullscreenElement !== null) || // HTML5 標準
    (document.mozFullScreenElement && document.mozFullScreenElement !== null) || // Firefox
    (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) || // Chrome・Safari
    (document.webkitCurrentFullScreenElement && document.webkitCurrentFullScreenElement !== null) || // Chrome・Safari (old)
    window.navigator.standalone || // iOS
    (document.msFullscreenElement && document.msFullscreenElement !== null)
  ) {
    return true
  }
  return false
}

function isIphone() {
  if (navigator.userAgent.indexOf('iPhone') > 0) {
    return true
  }
  return false
}
